import {apiFetch} from '@fitro/customer-host/api'

export type CustomerPartnerRecoveryOption = {
    slug: string
    displayName: string
    active: boolean
    customerStatus?: string | null
}

function isObjectRecord(value: unknown): value is Record<string, unknown> {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value)
}

function isCustomerPartnerRecoveryOption(value: unknown): value is CustomerPartnerRecoveryOption {
    if (!isObjectRecord(value)) return false

    return (
        typeof value.slug === 'string' &&
        value.slug.trim().length > 0 &&
        typeof value.displayName === 'string' &&
        typeof value.active === 'boolean' &&
        (
            value.customerStatus === undefined ||
            value.customerStatus === null ||
            typeof value.customerStatus === 'string'
        )
    )
}

function normalizeCustomerPartnerRecoveryOptions(value: unknown): CustomerPartnerRecoveryOption[] {
    if (!Array.isArray(value)) return []
    if (!value.every(isCustomerPartnerRecoveryOption)) return []
    return value
}

export async function listCustomerPartnerRecoveryOptions(): Promise<CustomerPartnerRecoveryOption[]> {
    const response = await apiFetch<unknown>('/api/public/customers/me/partners', {
        method: 'GET',
    })
    return normalizeCustomerPartnerRecoveryOptions(response)
}
